import React from "react"
import PropTypes from "prop-types"
import { getComponentDisplayName, constructOutputProps, nullCheckProps } from "../utils"

const jsonToData = expectedComponent => (json) => {
  if (!Array.isArray(json)) return undefined
  return json.map(({ name, props }) => {
    if (!expectedComponent) {
      throw Error("jsonToData expectedComponent not provided.")
    } else if (expectedComponent !== name) {
      console.warn(`jsonToData expecting ${expectedComponent} but received ${name}`)
    }
    return nullCheckProps(props)
  })
}
/**
 * Higher order component for parsing cms components to data components
 *
 * input: [{
 *    name: 'DataComponent',
 *    props: {
 *      someData: 1000
 *    }
 * } ...]
 * becomes
 * output: [{
 *    someData: 1000
 * } ...]
 *
 * @param {Object} options - Initial config options.
 * @param {Array} options.mapInputToOutput - Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
export default ({ expectedComponent, mapInputToOutput = [["components", "data"]] } = {}) => (Wrapped) => {
  const withDataComponents = props => (
    <Wrapped {...constructOutputProps(props, mapInputToOutput, jsonToData(expectedComponent))} />
  )
  withDataComponents.displayName = `withDataComponents(${getComponentDisplayName(Wrapped)})`

  withDataComponents.propTypes = {
    components: PropTypes.array,
    children: PropTypes.array
  }

  return withDataComponents
}



// WEBPACK FOOTER //
// ./src/higher-order-components/with-data-components.jsx